import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = ["src", "autoplay", "muted", "onLoadeddata", "onLoadstart"]
const _hoisted_3 = {
  key: 0,
  class: "loading-indicator"
}

import {
  ref,
  computed,
  watch,
  nextTick,
  onMounted,
  onBeforeUnmount,
} from "vue";


const __default__ = {
  name: "MultiVideoWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  config: {
    type: Object,
    required: true,
  },
  queueAudioPlaying: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const videoRefs = ref<HTMLVideoElement[]>([]);
const videoList = computed(() => {
  const src = props.config.src;
  if (!src || !Array.isArray(src)) return [];
  
  // Handle both string and object formats
  return src.map((item: any) => {
    if (typeof item === 'string') {
      return item;
    } else if (item && typeof item === 'object' && 'url' in item) {
      return item.url;
    }
    return '';
  }).filter((url: string) => url !== '');
});
const videoLoaded = ref<boolean[]>([]);
const currentIndex = ref(0);
const isActuallyMuted = ref(false);
let unmuteTimeout: number | null = null;

// Mute logic
watch(
  () => props.queueAudioPlaying,
  (newVal) => {
    if (newVal) {
      // mute when audio starts
      isActuallyMuted.value = true;
      if (unmuteTimeout) {
        clearTimeout(unmuteTimeout);
        unmuteTimeout = null;
      }
    } else {
      // unmute after 1 second when audio stops
      unmuteTimeout = window.setTimeout(() => {
        isActuallyMuted.value = false;
        unmuteTimeout = null;
      }, 1000);
    }
  },
  { immediate: true }
);

const muteVideo = computed(() => {
  if (props.config.muted) return true;
  return isActuallyMuted.value;
});

function onVideoLoaded(index: number) {
  videoLoaded.value[index] = true;
}

function onVideoLoadStart(index: number) {
  videoLoaded.value[index] = false;
}

function handleVideoError() {
  console.error("Error loading video:", videoList.value[currentIndex.value]);
  videoLoaded.value[currentIndex.value] = false;

  //move to next vid
  if (videoList.value && videoList.value.length > 0) {
    if (currentIndex.value < videoList.value.length - 1) {
      currentIndex.value += 1;
    } else if (props.config.loop) {
      currentIndex.value = 0;
    }

    // play next vid if autoplay is true
    if (props.config.autoPlay && videoRefs.value[currentIndex.value]) {
      nextTick(() => videoRefs.value[currentIndex.value]?.play());
    }
  }
}

function handleEnded() {
  if (!videoList.value || videoList.value.length === 0) return;

  if (props.config.loop) {
    currentIndex.value = (currentIndex.value + 1) % videoList.value.length;
  } else if (currentIndex.value < videoList.value.length - 1) {
    currentIndex.value += 1;
  }


  //pause prev video
  const prevVideo = videoRefs.value[currentIndex.value];
  if (prevVideo && !prevVideo.paused) {
    prevVideo.pause();
  }

  if (props.config.autoPlay && videoRefs.value[currentIndex.value]) {
    nextTick(() => videoRefs.value[currentIndex.value]?.play());
  }
}

onBeforeUnmount(() => {
  if (unmuteTimeout) clearTimeout(unmuteTimeout);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (src, index) => {
      return (_openBlock(), _createElementBlock("video", {
        key: index,
        src: src,
        autoplay: index == currentIndex.value && __props.config.autoPlay,
        muted: muteVideo.value,
        onEnded: handleEnded,
        onLoadeddata: ($event: any) => (onVideoLoaded(index)),
        onLoadstart: ($event: any) => (onVideoLoadStart(index)),
        onError: handleVideoError,
        class: _normalizeClass(["video-fill", { 'video-hidden': !videoLoaded.value[index] }]),
        style: _normalizeStyle({
        visibility: index == currentIndex.value ? 'visible' : 'hidden',
        zIndex: index === currentIndex.value ? 2 : 1,
        position: 'absolute',
        top: 0,
        left: 0,
      }),
        ref_for: true,
        ref_key: "videoRefs",
        ref: videoRefs
      }, null, 46, _hoisted_2))
    }), 128)),
    (!videoLoaded.value[currentIndex.value])
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "spinner" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})